export class BaseFormat {
  // molduraFixa: moldura obrigatória do evento (personalizaTotem/{uid}) para a
  // orientação da foto. Quando existe, ela já entra aplicada no canvas e o
  // cliente só pode trocar por outra do evento — nunca ficar sem moldura.
  constructor({ molduraFixa = null } = {}) {
    this.molduraFixa = molduraFixa || null;
  }

  get tipo() {
    throw new Error("Não implementado");
  }

  get canvasSize() {
    throw new Error("Não implementado");
  }

  get scaleFinal() {
    throw new Error("Não implementado");
  }

  get supportsOrientation() {
    return false;
  }

  // false → o editor não mostra o menu Molduras nem busca molduras.
  get supportsMolduras() {
    return true;
  }

  get defaultMoldura() {
    return this.molduraFixa;
  }

  get canvasCount() {
    return 1;
  }

  fitImageToCanvas(img, canvasSize) {
    if (img.width > img.height) {
      img.scaleToHeight(canvasSize.height);
      if (img.getScaledWidth() < canvasSize.width) {
        this._redimencionaRange("W", img, canvasSize);
      }
    } else {
      img.scaleToWidth(canvasSize.width);
      if (img.getScaledHeight() < canvasSize.height) {
        this._redimencionaRange("H", img, canvasSize);
      }
    }
  }

  _redimencionaRange(param, img, canvasSize) {
    const ffm = img.getObjectScaling();
    img._set("scaleX", ffm.scaleX + 0.001);
    img._set("scaleY", ffm.scaleY + 0.001);
    if (param == "W" && img.getScaledWidth() < canvasSize.width) {
      this._redimencionaRange(param, img, canvasSize);
    }
    if (param == "H" && img.getScaledHeight() < canvasSize.height) {
      this._redimencionaRange(param, img, canvasSize);
    }
  }

  // eslint-disable-next-line no-unused-vars
  filterMolduras(listaMolduras, orientationId) {
    return listaMolduras.filter((m) => m.dados.tipo === this.tipo);
  }
}
